import  { useEffect } from "react";

import Details from "../details/Details";
import HppWrapper from "./HppWrapper";
import Loader from "../loader/Loader.component";

const LangWrapper = ({
  isIbec = false,
  apiData,
  children,
  pblProduct,
  subscriptionProduct,
  slug,
  setDasLoader,
  allTrue
}: any) => {
  const { address: ADDRESS, company: COMPANY } = apiData;
  useEffect(() => {
    setDasLoader(true)
    let transactioContext: any = localStorage.getItem('transactionContext');
    try {
      transactioContext = JSON.parse(transactioContext)
    } catch (error) {

    }
    if (transactioContext) {
      if (isIbec) {
        const redirect_url = transactioContext.return_url.decline_url;
        localStorage.removeItem('transactionContext');
        if (redirect_url && localStorage.getItem("slug")===slug)
          window.location.href = redirect_url;
      } else {
        localStorage.removeItem('transactionContext');
      }
    }
    setDasLoader(false)
  }, []);


if(localStorage.getItem('transactionContext') && isIbec && localStorage.getItem("slug")===slug){
  return <>
  <Loader/>
  </>
}
  return (
    <HppWrapper apiData={apiData}
      allTrue={allTrue}
>
      <div className="flex-section">
        <div className="additional-product">
          {subscriptionProduct && subscriptionProduct}
          {pblProduct && pblProduct}
        </div>
        <div className="form-div">
          <Details
            COMPANY={COMPANY || ""}
            ADDRESS={ADDRESS || ""}
          />


          { children}
        </div>
      </div>

    </HppWrapper>
  );
};

export default LangWrapper;
